export enum Role {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  // OPERATIONS = 3,
  OPERATIONS = 16,
  TENANT_ADMIN = 5,
  NORMAL_TENANT_USER = Number(process.env.REACT_APP_NORMAL_TENANT_USER),
  LAB_STAFF_USER = 7,
  SUPER_TENANT_ADMIN = 8,
  HEALTH_COACH = 9,
  OPERATION_PLUS = 11,
}

export const TENANT_DASHBOARD_ROLE_LIMIT = [
  Role.TENANT_ADMIN,
  Role.SUPER_TENANT_ADMIN,
];

export enum ROLE_NAME {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  LABORATORY = 'Laboratory',
  CUSTOMER_SUPPORT = 'Customer Support',
  LAB_STAFF_USER = 'Lab Staff User',
  CLINIC = 'Clinic',
}

export enum AMILI_ROLE {
  ADMIN = 'Admin',
  CUSTOMER_SUPPORT = 'Customer Support',
  LAB_STAFF_USER = 'Lab Staff User',
}
